import { ColumnList, ColumnListContent, ColumnListPinned, ColumnListTrigger } from "@qw/ui";
import { InsuredLink } from "./insured-link";
import { useScopedItems } from "./use-book-scope";
import { type ItemWithInsured, usePinnedInsureds } from "./use-pinned-insureds";

export const BookList = <T,>({
  items,
  label,
  variant,
}: {
  items: ItemWithInsured<T>[];
  label: string;
  variant?: "default" | "renewal";
}) => {
  // Ahead of the pin split, so the count in the trigger is the count of rows below it. A pinned
  // insured outside the scope is still outside it — pinning is a broker's ordering preference, not
  // an exemption from the filter the chip says is on.
  const scopedItems = useScopedItems<T>(items);
  const [pinned = [], unpinned = []] = usePinnedInsureds<T>(scopedItems);

  return (
    <ColumnList label={label}>
      <ColumnListTrigger label={label} count={scopedItems.length} />
      {pinned.length > 0 && (
        <ColumnListPinned>
          {pinned.map((item) => (
            <InsuredLink key={item.insured.id} item={item} variant={variant} />
          ))}
        </ColumnListPinned>
      )}
      {unpinned.length > 0 && (
        <ColumnListContent>
          {unpinned.map((item) => (
            <InsuredLink key={item.insured.id} item={item} variant={variant} />
          ))}
        </ColumnListContent>
      )}
    </ColumnList>
  );
};
